import { render } from "./Collapse.vue?vue&type=template&id=f0bf4050"
import script from "./Collapse.vue?vue&type=script&lang=js"
export * from "./Collapse.vue?vue&type=script&lang=js"

import "./Collapse.vue?vue&type=style&index=0&id=f0bf4050&lang=css"
script.render = render

export default script